import { request } from '@/utils/request';
import { LeadParams } from '@/api/leads/leads.types';

export async function submitForm(form: LeadParams) {
  return request('/leads/submit/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    body: JSON.stringify(form),
  });
}